// extracted by mini-css-extract-plugin
export default {"blockwrapper":"XV","header":"YV","name":"ZV","columns":"aW","imagewrapper":"bW","addinfo":"cW","description":"eW","price":"fW","old":"gW","new":"hW","desc_d":"iW","infoblock":"jW","desc_m":"kW"};
    if(module.hot) {
      // 1726593107533
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  